<template>
	<div class="home">
		<div>
			<NavBar :nav="false" />
			<div v-if="list.length > 0">
				<van-checkbox-group v-model="result" :max="3">
					<div class="box" :class="{ act: check == index }" v-for="(item, index) in list" :key="index">
						<div class="title" @click="checkItem(index)">
							<div class="line"></div>
							<div class="text">{{ item.name }}</div>
							<div class="rig">
								<img src="../assets/images/up.png" alt="" />
							</div>
						</div>
						<div class="list">
							<div class="item" v-for="(child, index1) in item.drug" :key="index1">
								<van-checkbox :name="child.id" shape="square" @click="onChange(child)">
									<span>{{ child.name }}</span>
								</van-checkbox>
							</div>
						</div>
					</div>
				</van-checkbox-group>

				<div class="applywrap"></div>
				<div class="apply">
					<div class="btn" :class="{ act: result.length > 0 }" @click="apply()">
						申请
						<span v-if="result.length > 0">({{ result.length }})</span>
					</div>
				</div>
			</div>

			<div v-else class="empty">{{ loading ? '加载中...' : '暂无内容' }}</div>

			<float-btn :sample="true"></float-btn>
		</div>

		<div class="popup" v-if="showPopup">
			<div class="wrap">{{ text }}</div>
		</div>
	</div>
</template>

<script>
import { Toast } from 'vant';
import floatBtn from '@/components/FloatBtn.vue';
import Loading from '@/components/Loading.vue';
import NavBar from '@/components/NavBar.vue';
export default {
	components: {
		floatBtn,
		Loading,
		NavBar
	},
	data() {
		return {
			show: true,
			datails: {},
			loading: true,
			result: [],
			loading: true,
			list: [],
			check: 0,
			text: '',
			showPopup: false,
			max: false,
			title: []
		};
	},
	watch: {
		result(newValue, oldValue) {
			// console.log('原值:' + oldValue + '新值:' + newValue)
			this.checkNum = this.result.length;
			if (newValue.length < 3) {
				this.max = false;
			}
		}
	},
	mounted() {
		// 页面浏览 监测
		this.$dataStatistics({
			page_title: '样品申请列表'
		});
		this.initShare();
		this.getList();
	},
	methods: {
		getList() {
			this.loading = true;
			this.$http.get('/api/platform/sampledrug').then((res) => {
				// console.log('res', res);
				this.list = res.data;
				this.loading = false;
			});
		},
		onChange(child) {
			if (this.result.includes(child.id)) {
				this.title.push(child.name);
			} else {
				const index = this.title.indexOf(child.name);
				if (index > -1) {
					this.title.splice(index, 1);
				}
			}

			if (this.max) {
				this.text = '最多同时选择申请3个样品';
				this.showPopup = true;

				if (this.showPopup) {
					setTimeout(() => {
						this.showPopup = false;
					}, 1500);
				}
			}
			if (this.result.length == 3) {
				this.max = true;
			} else if (this.result.length < 3) {
				this.max = false;
			}
		},
		checkItem(index) {
			this.check = this.check === index ? null : index;
		},
		apply() {
			if (this.result.length == 0) {
				this.text = '请选择样品';
				this.showPopup = true;
			} else if (this.result.length > 3) {
				this.text = '同时最多选择申请3个样品';
				this.showPopup = true;
			} else {
				console.log(this.result + '');
				this.$router.push({
					path: '/sampleform',
					query: {
						ids: this.result + '',
						title: this.title + ''
					}
				});
			}

			if (this.showPopup) {
				setTimeout(() => {
					this.showPopup = false;
				}, 1500);
			}
		}
	}
};
</script>
<style lang="less" scoped>
.home {
	width: 100%;
	padding: 30px 40px;
	background: rgba(249, 247, 243, 0.66);
}

.box {
	width: 100%;
	// background-color: rgba(255, 255, 255, .6);
	margin-bottom: 30px;

	.list {
		width: 100%;
		height: 0;
		overflow: hidden;

		.item {
			width: 100%;
			min-height: 86px;
			background: rgba(255, 255, 255, 0.4);
			display: flex;
			// align-items: center;
			padding: 22px 30px;
			margin-bottom: 1px;

			::v-deep .van-checkbox {
				align-items: flex-start;
			}

			::v-deep .van-checkbox__icon {
				height: 24px;
				margin-top: 9px;
			}

			::v-deep .van-checkbox__icon .van-icon {
				width: 24px;
				height: 24px;
				background: #e4e1df;
				border: 1px solid #999999;
				font-size: 0.45em;
			}

			::v-deep .van-checkbox__icon--checked .van-icon {
				background: #991d85;
				border: 1px solid #991d85;
			}

			span {
				width: calc(100% - 54px);
				font-size: 28px;
				font-weight: normal;
				color: #101010;
				word-break: break-all;
			}
		}
	}

	.title {
		width: 100%;
		height: 86px;
		background: rgba(255, 255, 255, 0.3);
		box-shadow: -1px 9px 29px 0px rgba(0, 0, 0, 0.13);
		display: flex;
		align-items: center;

		.line {
			width: 6px;
			height: 47px;
			background: #991d85;
			margin-right: 30px;
		}

		.text {
			width: calc(100% - 90px);
			font-size: 30px;
			font-weight: normal;
			color: #000000;
		}

		.rig {
			width: 53px;
			padding-right: 30px;

			img {
				width: 23px;
				height: 13px;
				transition: 0.2s;
			}
		}
	}
}

.box.act {
	.title {
		img {
			transform: rotate(180deg);
		}
	}

	.list {
		height: auto;
	}
}
.applywrap {
	width: 100%;
	height: 160px;
}
.apply {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	z-index: 22;
	padding: 0 26px 60px;

	.btn {
		width: 100%;
		height: 90px;
		background: #cccccc;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 34px;
		color: #ffffff;
	}

	.act {
		background: #991d85;
	}
}

.popup {
	position: fixed;
	left: 0;
	top: 0;
	z-index: 9999;
	width: 100%;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.7);
	display: flex;
	align-items: center;
	justify-content: center;
	padding-bottom: 10%;

	.wrap {
		width: 479px;
		height: 276px;
		background: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 28px;
		color: #000000;
		text-align: center;
	}
}
</style>
